import React from 'react'
import { useLocation } from 'react-router-dom'
import { MenuSidebarItem } from './menuSidebarItem'
import { Container, MenuSidebarLoader } from './styles'
import { SupportContact } from './supportContact'
import { MenuSidebarFeedbackItem } from '../feedback/MenuSidebarFeedbackItem'
import { Divider } from '~/styles'
import { usePatient, useLastSelectedMedicalView } from '~/context'
import {
  ALLERGIES_PATH,
  ANALYTICAL_MODELS_PATH,
  DEFAULT_PATH,
  DIAGNOSES_PATH,
  FETAL_DIAGNOSES_PATH,
  SEARCH_PATIENT_PATH
} from '~/constants'

interface MenuSidebarProps {
  isCollapsed: boolean
}

export const MenuSidebar = ({ isCollapsed }: MenuSidebarProps): JSX.Element => {
  const location = useLocation()
  const { patient } = usePatient()
  const { lastSelectedMedicalView } = useLastSelectedMedicalView()

  const isActualRoute = (expectedRoute: string): boolean => {
    const actualRoute = location.pathname
    return actualRoute.includes(expectedRoute)
  }

  const renderDiagnosisFetal = () => {
    if (lastSelectedMedicalView === 'visao-materno-infantil') {
      return (
        <MenuSidebarItem
          id="diagnosticos-fetais"
          buttonLabel="Diagnósticos Fetais"
          to={`/${DEFAULT_PATH}/${FETAL_DIAGNOSES_PATH}/${patient?.medicalRecord}`}
          isActive={isActualRoute(`${FETAL_DIAGNOSES_PATH}/${patient?.medicalRecord}`)}
          linkIcon="fetalDiagnosis"
          isCollapsed={isCollapsed}
        />
      )
    }
  }

  return (
    <Container>
      <ul role="menubar">
        {patient?.medicalRecord ? (
          <>
            <MenuSidebarItem
              id="novaBusca"
              buttonLabel="Nova Busca"
              to={`/${DEFAULT_PATH}/${SEARCH_PATIENT_PATH}`}
              isActive={isActualRoute(SEARCH_PATIENT_PATH)}
              linkIcon="contentPasteSearch"
              isCollapsed={isCollapsed}
            />
            <MenuSidebarItem
              id="linhaDoTempo"
              buttonLabel="Linha do Tempo"
              to={`/${DEFAULT_PATH}/${lastSelectedMedicalView}/${patient.medicalRecord}`}
              isActive={isActualRoute('visao')}
              linkIcon="accountTree"
              isCollapsed={isCollapsed}
            />
            <MenuSidebarItem
              id="diagnosticos"
              buttonLabel="Diagnósticos"
              to={`/${DEFAULT_PATH}/${DIAGNOSES_PATH}/${patient.medicalRecord}`}
              isActive={isActualRoute(`${DIAGNOSES_PATH}/${patient?.medicalRecord}`)}
              linkIcon="stethoscopeThin"
              isCollapsed={isCollapsed}
            />
            {renderDiagnosisFetal()}
            <MenuSidebarItem
              id="alergias"
              buttonLabel="Alergias"
              to={`/${DEFAULT_PATH}/${ALLERGIES_PATH}/${patient.medicalRecord}`}
              isActive={isActualRoute(ALLERGIES_PATH)}
              linkIcon="grain"
              isCollapsed={isCollapsed}
            />
            <MenuSidebarItem
              id="modelosAnaliticos"
              buttonLabel="Modelos Analíticos"
              to={`/${DEFAULT_PATH}/${ANALYTICAL_MODELS_PATH}/${patient.medicalRecord}`}
              isActive={isActualRoute(ANALYTICAL_MODELS_PATH)}
              linkIcon="analytics"
              isCollapsed={isCollapsed}
            />
            <Divider orientation="horizontal" marginBottom="1rem" />
            <SupportContact isCollapsed={isCollapsed} />
            <MenuSidebarFeedbackItem isCollapsed={isCollapsed} />
          </>
        ) : (
          <>
            <MenuSidebarLoader />
            <Divider orientation="horizontal" />
            <MenuSidebarLoader count={1} />
          </>
        )}
      </ul>
    </Container>
  )
}
